export const routes = [
  {
    path: '/digital-commisions/:type?',
    name: 'DigitalCommisions',
    component: () => import('@/app/modules/DigitalCommisions/views/DigitalCommisions.vue'),
  },
  {
    path: '/digital-commisions/business-tip',
    name: 'BusinessTip',
    component: () => import('@/app/modules/DigitalCommisions/views/BusinessTip.vue'),
  },
  {
    path: '/digital-commisions/:type/:action/:id',
    name: 'DigitalCommissionCard',
    component: () => import('@/app/modules/DigitalCommisions/views/DigitalCommissionCard.vue'),
  },
  {
    path: '/digital-commisions/commissions',
    name: 'DigitalCommissionsTable',
    component: () => import('@/app/modules/DigitalCommisions/views/DigitalCommissionsTable.vue'),
  },
];
